import { Link } from 'react-router-dom';

const ConsultingImplementation = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Consulting &amp; Implementation</h1>
          <p>
            Nexus IT guides organizations through every stage of digital transformation—from strategy and solution
            design to implementation and knowledge transfer.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container split">
          <div className="text-block">
            <span className="badge">Consulting Services</span>
            <h2>Strategic Advisory</h2>
            <p>
              Our consultants collaborate with business and technology stakeholders to craft pragmatic roadmaps. We
              align capabilities to objectives, evaluate existing investments, and define actionable transformation
              initiatives.
            </p>
            <ul className="checklist">
              <li>Digital strategy development and business case creation</li>
              <li>Architecture assessments and modernization roadmaps</li>
              <li>Vendor evaluation, RFP development, and procurement support</li>
              <li>Governance frameworks to ensure sustainable adoption</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>Implementation Expertise</h3>
            <ul>
              <li>Project management offices ensuring scope, timeline, and budget discipline</li>
              <li>Technical deployment teams with multi-domain certifications</li>
              <li>Integration, migration, and acceptance testing services</li>
              <li>Documentation, enablement, and post go-live support</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Delivery Methodology</span>
            <h2 className="section-title">Structured, Transparent Engagement</h2>
          </div>
          <div className="process-steps">
            <article className="process-step">
              <h4>Discovery</h4>
              <p>Stakeholder interviews, current-state assessment, and requirement gathering.</p>
            </article>
            <article className="process-step">
              <h4>Design</h4>
              <p>Solution blueprints, architecture validation, and implementation planning.</p>
            </article>
            <article className="process-step">
              <h4>Deploy</h4>
              <p>Configuration, integration, migration, and rigorous testing.</p>
            </article>
            <article className="process-step">
              <h4>Adopt</h4>
              <p>Change management, training, documentation, and operational handover.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Launch Your Next Initiative</h2>
              <p>Partner with Nexus IT to translate strategy into successful technology execution.</p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Connect Today
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConsultingImplementation;
